import React, { ReactElement } from "react";
import { skeletonLoaderCSS } from "./SkeletonLoader.styles";

export const SkeletonLoader = (): ReactElement => (
  <div style={{ minHeight: 50 }}>
    <div className={`${skeletonLoaderCSS} spark-mar-b-.5 step1`}></div>
    <div className={`${skeletonLoaderCSS} spark-mar-b-.5 step2`}></div>
    <div className={`${skeletonLoaderCSS} spark-mar-b-.5 step3`}></div>
  </div>
);
